import { action, makeObservable, observable, reaction } from 'mobx';

class CheckoutRepository {
  isModalOpen = false;
  checkoutType = null;

  constructor() {
    makeObservable(this, {
      isModalOpen: observable,
      toggleModal: action,
    });
  }

  load(callback) {
    reaction(
      () => this.isModalOpen,
      () =>
        callback({
          isModalOpen: this.isModalOpen,
          checkoutType: this.checkoutType,
        }),
      { fireImmediately: true }
    );
  }
  closeModal = () => {
    this.isModalOpen = false;
  };

  toggleModal = ({ type }) => {
    this.isModalOpen = !this.isModalOpen;

    if (type) {
      this.checkoutType = type;
    }
  };
}

const checkoutRepository = new CheckoutRepository();

export default checkoutRepository;
